import React from 'react';
import { Text, VStack } from '@chakra-ui/react';
import { LOOP_TEXT_COLUMN_MAX_WIDTH } from '@/constants/contentFeed';
import CreatorIdentity from '@/modules/content/loop/parts/CreatorIdentity';
import LoopTitle from '@/modules/content/loop/parts/LoopTitle';
import PublishedMetaRow from '@/modules/content/loop/parts/PublishedMetaRow';
import { dimUntilHoverGroup } from '@/modules/content/loop/model/loopChrome';
import { TContent, TContentReportReason } from '@/types/Content.types';

type Props = {
  content: TContent;
  onNotInterested: () => void;
  onReport: (reason: TContentReportReason) => void;
  children?: React.ReactNode;
  // Rests dimmed beside a reel so the video holds the focus. Not used on articles, where
  // this column *is* the content and there is no video to defer to.
  isDimmed?: boolean;
};

// The attribution column that sits beside portrait media on the reel and article variants.
// Fills whatever the left zone offers, up to a comfortable reading measure.
const TextColumn = ({ content, onNotInterested, onReport, children, isDimmed = false }: Props) => (
  <VStack
    align="stretch"
    gap="10px"
    width="100%"
    maxWidth={{ base: '100%', md: LOOP_TEXT_COLUMN_MAX_WIDTH }}
    {...(isDimmed ? dimUntilHoverGroup : {})}
  >
    <CreatorIdentity content={content} onNotInterested={onNotInterested} onReport={onReport} />
    <LoopTitle>{content.title || 'Untitled'}</LoopTitle>
    {content.description && (
      <Text fontSize="13px" color="text.mediumBlue" lineHeight="19px" noOfLines={4}>
        {content.description}
      </Text>
    )}
    <PublishedMetaRow content={content} />
    {children}
  </VStack>
);

export default TextColumn;
